import { PropsWithChildren } from 'react';

import { makeStyles } from '@material-ui/core';

import { Content as BackstageContent } from '@backstage/core-components';

import { NarrowBox, NarrowBoxProps } from './NarrowBox';

const useStyles = makeStyles({
  // The BUI theme adds paddingTop via a high-specificity selector
  // (div:has([role=tablist]) + &) that overrides BackstageContent's
  // noPadding class. This re-asserts padding: 0 with !important.
  // The inner MUI Stack child also has its own padding that must be
  // zeroed out.
  noPadding: {
    padding: '0 !important',
    '& > [class*="MuiStack-root"]': {
      padding: 0,
    },
  },
});

export type ContentProps = PropsWithChildren<{
  narrow?: boolean | NarrowBoxProps['width'];
  className?: string;
  noPadding?: boolean;
}>;

export const Content = ({
  children,
  narrow,
  className,
  noPadding,
}: ContentProps) => {
  const classes = useStyles();
  return (
    <BackstageContent
      className={
        noPadding
          ? [classes.noPadding, className].filter(Boolean).join(' ')
          : className
      }
      noPadding={noPadding}
    >
      {narrow ? (
        <NarrowBox width={typeof narrow === 'string' ? narrow : undefined}>
          {children}
        </NarrowBox>
      ) : (
        children
      )}
    </BackstageContent>
  );
};
